<template>
  <div class="app-panel">
    <div class="app-panel__header" v-if="hasHeaderSlot">
      <slot name="panel-header"></slot>
    </div>
    <div class="app-panel__top-bar" v-if="hasTopBarSlot">
      <slot name="panel-top-bar"></slot>
    </div>
    <div
      class="app-panel__body" v-if="hasBody">
      <slot name="panel-body"></slot>
    </div>
  </div>
</template>

<script>

export default {
  computed: {
    hasHeaderSlot() {
      return !!this.$slots['panel-header'];
    },
    hasTopBarSlot() {
      return !!this.$slots['panel-top-bar'];
    },
    hasBody() {
      return !!this.$slots['panel-body'];
    },
  },
};
</script>

<style lang="sass" scoped>
@import "src/styles/defaults/variables"
@import "src/styles/defaults/mobile-first"
@import "src/styles/defaults/mixins"

.app-panel
  border-radius: 5px
  position: relative
  display: flex
  flex-direction: column
  border: 1px solid var(--color-border-outer)
  +md-box-shadow-1
  &__header
    background-color: var(--color-background-dark)
    padding: 7px 15px
    border-top-left-radius: 5px
    border-top-right-radius: 5px
    > label:only-child
      margin-bottom: initial
  &__body
    overflow: auto
    border-bottom-left-radius: 5px
    border-bottom-right-radius: 5px
    flex: 1
  &__top-bar
    background-color: var(--color-background-regular)
  +media-min-sm()
  +media-min-md()
  +media-min-lg()
</style>
